import { Text } from "@radix-ui/themes";
import { twMerge } from "tailwind-merge";

interface ActionCardProps {
  icon: React.ReactNode;
  title: string;
  description?: string;
  gradient?: boolean;
  onClick: () => void;
  className?: string;
  children?: React.ReactNode;
}

export const ActionCard = ({
  icon,
  title,
  description,
  gradient,
  onClick,
  className,
  children,
}: ActionCardProps) => (
  <div
    className={twMerge(
      "p-5 rounded-xl cursor-pointer transition-shadow hover:shadow-lg",
      gradient
        ? "bg-gradient-to-br from-indigo-500 via-purple-500 to-pink-500 text-white"
        : "bg-slate-100 dark:bg-slate-900 hover:bg-slate-200 dark:hover:bg-slate-800",
      className
    )}
    onClick={onClick}
  >
    <div
      className={
        gradient ? "text-white" : "text-indigo-600 dark:text-indigo-400"
      }
    >
      {icon}
    </div>
    <Text className="font-semibold block mt-2">{title}</Text>
    {!!description && (
      <Text
        className={twMerge(
          "text-sm block mt-1",
          gradient ? "text-white/80" : "text-slate-500 dark:text-slate-400"
        )}
      >
        {description}
      </Text>
    )}
    {children}
  </div>
);
